import { observer } from 'mobx-react-lite';

import { LoadingRigOperations, WellRigOperationStage } from '../../../presets/drilling-wells-chart/entities';
import type { WellsViewSettingsProvider } from '../../../presets/drilling-wells-chart/wells-view-settings-provider';
import type { Viewport } from '../../../shared/viewport/viewport';
import type { WellsChartDataModel } from '../../wells-chart/data/wells-chart-data-model';

import { WellsDataItem } from './wells-data-item';

interface Props {
  data: WellsChartDataModel.ViewItemContent[];
  horizontalViewport: Viewport;
  verticalViewport: Viewport;
  viewProvider: WellsViewSettingsProvider;
  onWellStageClick(wellId: number): void;
}

export const WellsDataItemsEmpty = observer(function DataItems({
  data,
  horizontalViewport,
  verticalViewport,
  viewProvider,
  onWellStageClick,
}: Props) {
  return (
    <>
      {data.map((item) => {
        if (item instanceof WellRigOperationStage || item instanceof LoadingRigOperations) {
          return (
            <WellsDataItem
              key={item.getKey()}
              item={item}
              horizontalViewport={horizontalViewport}
              verticalViewport={verticalViewport}
              viewProvider={viewProvider}
              onWellStageClick={onWellStageClick}
            />
          );
        }

        return null;
      })}
    </>
  );
});
